import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Customer, CustomerSelectDropdownComponent } from 'gung-standard';
import { first } from 'rxjs';

@Component({
  selector: 'app-hl-display-customer-selection-typeahead',
  standalone: false,
  templateUrl: './hl-display-customer-selection-typeahead.component.html',
  styleUrl: './hl-display-customer-selection-typeahead.component.css'
})
export class HlDisplayCustomerSelectionTypeaheadComponent extends CustomerSelectDropdownComponent implements OnInit, OnChanges {
  @Input() startSelectedCustomerId: string;

  ngOnInit() {
    if (!!this.startSelectedCustomerId) {
      this.selectedCustomer = this.customerService.getCustomer(this.startSelectedCustomerId).pipe(first());
      this.selectedCustomer.subscribe(customer => {
        this.model = this.formatter(customer);
      });
    }
    this.customerService.getCustomers().pipe(first()).subscribe(customers => this.customers = customers);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.startSelectedCustomerId) {
      if (!!this.startSelectedCustomerId) {
        this.selectedCustomer = this.customerService.getCustomer(this.startSelectedCustomerId).pipe(first());
        this.selectedCustomer.subscribe(customer => {
          this.model = this.formatter(customer);
        });
      }
    }
  }

  onItemSelect(event: NgbTypeaheadSelectItemEvent) {
    const cust = event.item as Customer;
    this.model = this.formatter(cust);
    event.preventDefault();
    this.customerSelected.emit(cust);
  }
}
